import styled from 'styled-components'

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  padding: 4px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 11px;
  background: ${({ theme }) => theme.palette.colors.controlSurface};
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
`;
export const Tab = styled.button`
  min-height: 34px;
  padding: 7px 16px;
  border: 0;
  border-radius: 8px;
  background: ${({ active, theme }) => active ? theme.palette.colors.cardSurface : 'transparent'};
  color: ${({ active, theme }) => active ? theme.palette.colors.text : theme.palette.colors.muted};
  box-shadow: ${({ active, theme }) => active ? theme.palette.colors.cardShadow : 'none'};
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  &:hover { color: ${({ theme }) => theme.palette.colors.text}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 2px; }
`;
